import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-transactions-history',
  templateUrl: './transactions-history.component.html',
  styleUrls: ['./transactions-history.component.scss']
})
export class TransactionsHistoryComponent implements OnInit {
  @Input() history:any;
  page = 1;
  pageSize = 5;
  constructor() { }

  ngOnInit(): void {
  }

}
